import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Rating } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class RatingModule extends VuexModule {
    @Action
    [Rating.getRatingList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/ratings/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Rating.findPageRating](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/ratings`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Rating.saveRating](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/ratings/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Rating.deleteRating](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/ratings/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}